var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoipsum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-51",
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.95,
    height: 24.06,
    viewBox: "0 0 138.95 24.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2f234f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,23.59V0H8.65C13.3,0,16,2.74,16,6.73A5.24,5.24,0,0,1,13.43,11,5.8,5.8,0,0,1,17,16.42c0,4.4-2.8,7.17-7.55,7.17ZM8.3,4.53H5.18V9.47H8.3a2.35,2.35,0,0,0,2.54-2.16,2.44,2.44,0,0,0,0-.27A2.42,2.42,0,0,0,8.5,4.53ZM5.18,13.4V19h3c1.86,0,3.53-.51,3.53-2.83,0-2.14-2.17-2.83-3.53-2.83Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.75,15v1.64h-12a4,4,0,0,0,4,2.92,4.73,4.73,0,0,0,3.81-1.44L35,20.82a10.42,10.42,0,0,1-7.3,3.24c-5.72,0-8.52-4.78-8.52-9S22.45,6,27.67,6C33.14,6,35.75,11.29,35.75,15ZM24,12.77h7.26a3.78,3.78,0,0,0-3.49-2.64A4,4,0,0,0,24,12.77Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.71,10.88c0,.35.34.6,1.35,1,4.4,1.6,7.11,3.2,7.11,6.85,0,3-2.58,5.35-6.29,5.35a8.81,8.81,0,0,1-7.33-3.93L41,17.58a4.6,4.6,0,0,0,3.36,1.86c.76,0,1.7-.22,1.7-.73,0-.94-1.54-1.41-2.48-1.76-4.31-1.63-5.73-3.43-5.73-6.16S40.49,6,44.08,6A8.45,8.45,0,0,1,50.9,8.81l-3.39,2.51a5.25,5.25,0,0,0-3-1.19C43.71,10.13,42.71,10.28,42.71,10.88Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59.75,2.53V6.46h4.47v4.77H59.75v7.3c0,.63.16,1,.54,1,.56,0,1.35-1.13,1.6-1.51l3.62,2.7c-1.8,2.3-3.18,3.37-5.22,3.37-2.8,0-5.66-1.79-5.66-5.28V11.23H52.55V6.45h2.08V2.53Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.68,20.35a9.06,9.06,0,1,1-.22-10.91l-3.74,2.83A4.18,4.18,0,0,0,71.2,15,4.23,4.23,0,0,0,79,17.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.62,23.59l-.22-2.14A6.46,6.46,0,0,1,92,24.06c-4.19,0-8.15-3.49-8.15-9s4.43-9,8.15-9a6.49,6.49,0,0,1,5.47,2.61l.22-2.14h4.9V23.59ZM93.31,10.44A4.51,4.51,0,0,0,88.91,15a4.45,4.45,0,0,0,4.4,4.5A4.4,4.4,0,0,0,97.65,15v0A4.57,4.57,0,0,0,93.31,10.44Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.39,10.88c0,.35.34.6,1.35,1,4.4,1.6,7.11,3.2,7.11,6.85,0,3-2.58,5.35-6.29,5.35a8.81,8.81,0,0,1-7.33-3.93l3.43-2.55A4.6,4.6,0,0,0,112,19.46c.76,0,1.7-.22,1.7-.73,0-.94-1.54-1.41-2.48-1.76-4.31-1.63-5.73-3.43-5.73-6.16S108.19,6,111.77,6a8.47,8.47,0,0,1,6.83,2.83l-3.4,2.51a5.25,5.25,0,0,0-3-1.19C111.39,10.13,110.39,10.28,110.39,10.88Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.9,0V8.81A7.08,7.08,0,0,1,132.12,6c3.65,0,6.82,1.69,6.82,8.24v9.37h-5.12V15.22c0-3.17-.69-4.53-2.9-4.53a4.44,4.44,0,0,0-4,2.58V23.59h-5.15V0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoipsum);
export default __webpack_public_path__ + "static/media/logoipsum.04ccc25cb855c1a6d7b6408ca1f5253a.svg";
export { ForwardRef as ReactComponent };